import './App.css';
import Router from './routes/Router';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
  return (
   <>
   <Router/> 
   <ToastContainer position="top-right" autoClose={5000}
    style={{ zIndex: 999999 }}
   />
   </>
  );
}

export default App;
